<template>
  <div class="nav-item">
    <router-link tag="a" :to="resolvePath(item.path)"><svg-icon v-if="item.note" :icon-class="item.note"></svg-icon>{{ item.name }}</router-link>
  </div>
</template>

<script>
  import path from 'path'
  export default {
    name: 'NavItem',
    props: {
      // route配置json
      item: {
        type: Object,
        required: true
      },
      basePath: {
        type: String,
        default: ''
      }
    },
    methods: {
      resolvePath: function(...paths) {
        return path.resolve(this.basePath, ...paths)
      }
    }
  }
</script>

<style scoped>

  .nav-item {
    margin-right: 34px;
    font-size: 14px;
  }
  .svg-icon {
    margin-right: 8px;
    color: #d5d9da;
    font-size: 1.3em;
  }
</style>